import PageLayout1 from "./PageLayout1";
import PageLayout2 from "./PageLayout2";

export {PageLayout1, PageLayout2}